<template>
    <modal @close="closeFromModal">
        <h5 slot="header">{{ $tl("labels.clickAndCollect.modals.titles.detailsOrder") }}</h5>
        <div slot="body">
            <show-command :hide_client_btn="hide_client_btn" :command_id="command_id" :restaurant_id="restaurant_id" />
        </div>
        <div slot="footer" class="d-flex w-100 justify-content-between">
            <button class="modal-default-button btn-sm btn btn-secondary btn-circle" @click="close">{{ $tl("labels.form.actions.close") }}</button>
        </div>
    </modal>
</template>

<script>
import ShowCommand from "../../clickAndCollect/Command/Show.vue";

export default {
    props: {
        command_id: {
            default: "",
        },
        restaurant_id: {
            default: "",
        },
        hide_client_btn: {
            default: false,
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
    components: {
        ShowCommand,
    },
};
</script>
